import PanelFiltresV2 from './components/PanelFiltresV2'

const FiltresSection = (): JSX.Element => (
  <div>
    <PanelFiltresV2 />
  </div>
)

export default FiltresSection
